import closeIcon from "./../../assets/closeIcon.png";

function GeneralModal({ title, message, setShow, setLink, link }) {
  const closeModal = () => {
    setShow(false);
    setLink(false);
  };

  return (
    <div>
      <section className="nft-modal dark-modal">
        <div className="modal-dialog">
          <div className="modal-content">
          <div className="modal-header">
        <h5 className="modal-title text-white">{title}</h5>
        <button onClick={closeModal} type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
            <div className="modal-body">
              <div>
                <div>
                  <div className="text-muted text-center ln-2 mt-3">
                    {message}
                  </div>
                </div>
                <br />
                <div className="text-center d-flex">
                  {link ? <a href={link} target='_blank' className='btn btn-theme-primary w-100 mr-25'>View Transaction</a> : ""}
                  <button onClick={closeModal} className="btn btn-theme-primary w-100">
                    Okay
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default GeneralModal;
